import React from 'react';
import './CharacterCounter.css';

interface Props {
  currentLength: number;
  maxLength: number;
  warningThreshold?: number;
}

export const CharacterCounter: React.FC<Props> = ({
  currentLength,
  maxLength,
  warningThreshold = 1800
}) => {
  const getClassName = () => {
    if (currentLength >= maxLength) return 'char-counter error';
    if (currentLength >= warningThreshold) return 'char-counter warning';
    return 'char-counter';
  };

  return (
    <div className={getClassName()}>
      {currentLength} / {maxLength} characters
      {currentLength >= maxLength && (
        <span className="char-counter-error-msg">
          Message cannot exceed {maxLength} characters
        </span>
      )}
    </div>
  );
};
